export default __webpack_public_path__ + "static/media/bg-eat-fresh-subheader.b3a9c699.jpg";